import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Wrench, 
  ArrowLeft, 
  Code, 
  Rocket,
  Clock
} from 'lucide-react';
import styles from './UnderDevelopment.module.css';

const UnderDevelopment: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/defineui/assigned-studies');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Animated Icon */}
        <div className={styles.iconWrapper}>
          <div className={styles.iconCircle}>
            <Wrench className={styles.mainIcon} />
          </div>
          <div className={styles.floatingIcons}>
            <Code className={styles.floatingIcon} />
            <Rocket className={styles.floatingIcon} />
            <Clock className={styles.floatingIcon} />
          </div>
        </div>

        {/* Title */}
        <h1 className={styles.title}>
          🚧 Under Development
        </h1>

        {/* Description */}
        <p className={styles.description}>
          This feature is currently being built by our team.
          <br />
          We're working hard to bring you an amazing experience!
        </p>

        {/* Features List */}
        <div className={styles.featuresList}>
          <div className={styles.featureItem}>
            <div className={styles.featureDot}></div>
            <span>Coming Soon</span>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureDot}></div>
            <span>Enhanced Features</span>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureDot}></div>
            <span>Better Performance</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <button 
            onClick={handleGoBack}
            className={styles.secondaryButton}
          >
            <ArrowLeft size={18} />
            Go Back
          </button>
          <button 
            onClick={handleGoHome}
            className={styles.primaryButton}
          >
            Go to Home
          </button>
        </div>

        {/* Progress Indicator */}
        <div className={styles.progressSection}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill}></div>
          </div>
          <p className={styles.progressText}>
            Development in progress...
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnderDevelopment;